import {
  Button,
  Typography,
  TypographyMods,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';
import React from 'react';

import MessageIcon from '~public/static/images/icons/tech_support.svg';
import SignInIcon from '~public/static/images/icons/user_outline.svg';
import { Goals } from '~services/Goals';
import { URLS } from '~types/Urls.types';

import styles from './HeaderHrTekUser.module.scss';
import { HeaderHrTekUserProps } from './HeaderHrTekUser.types';

export const HeaderHrTekUser = ({ mod, className }: HeaderHrTekUserProps) => {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();

    Goals.gtag4({ event: 'entrance_lk' });
    Goals.ym({
      event: 'reachGoal',
      action: 'entrance_lk',
    });

    const newWindow = window.open(
      URLS?.Vkdoc || '',
      '_blank',
      'noopener,noreferrer',
    );
    if (newWindow) newWindow.opener = null;
  };

  const handleClickSupport = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();

    Goals.gtag4({ event: 'click_contact' });
    Goals.ym({
      event: 'reachGoal',
      action: 'click_contact',
    });

    const link = document.createElement('a');
    link.href = URLS?.HrTekSupport || '';
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  };

  return (
    <div
      className={classNames(styles.wrapper, className, {
        [styles[mod]]: mod,
      })}
    >
      <div className={styles.contacts}>
        <Typography mods={[TypographyMods.bodyS]} className={styles.email}>
          <a href="mailto:sales@hrtek.ru">sales@hrtek.ru</a>
        </Typography>
      </div>
      <div className={styles.actionsDesktop}>
        <Button
          className={styles.buttonSupport}
          onClick={handleClickSupport}
          size="m"
          mod="tertiary"
        >
          <MessageIcon className={styles.buttonIcon} />
          <span className={styles.textHidden}>Связаться с техподдержкой</span>
        </Button>
        <Button
          className={styles.userSignIn}
          size="m"
          mod="secondary"
          href={URLS?.Vkdoc || ''}
          onClick={handleClick}
          target="_blank"
        >
          <SignInIcon className={styles.buttonUserSignInIcon} />
          <span className={styles.textHidden}>Личный кабинет</span>
        </Button>
      </div>
    </div>
  );
};
